<template>
    <el-dialog :visible.sync="dialogVisible" title="新功能介绍"
               :show-close="false"
               custom-class="news-view"
               class="global-dialog"
               width="700px"
               :close-on-click-modal="false">
        <div class="dialog-body">
            <section >
                    <el-carousel v-show="currentItem.content" trigger="click" height="200px" :autoplay="false" indicator-position="outside">
                        <el-carousel-item v-for="(url, cIndex) in currentItem.content.split(',')" :key="cIndex">
                            <div class="img-view-content">
                                <img :src="url" />
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                    <p class="sec-text">
                        {{ currentItem.name }}
                    </p>
            </section>
        </div>
        <div slot="footer">
            <el-button type="default" @click="onClose">关闭</el-button>
            <el-button type="primary" @click="onNextNews">我知道了</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import newsService from '@/request/service/news-service';
    export default {
        props:{
            value: Boolean
        },
        data() {
            return {
                currentItem: {id: null ,name: '', content: ''},
                currentIdx: 0
            };
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            },
        },
        watch:{
            dialogVisible:{
                handler(v){
                    if(v){
                        this.init();
                    }
                }
            },
            immediate: true
        },
        methods: {
            init() {
                this.nextNews(0);
            },
            onNextNews(){
                let dataList = this.$store.state.app.loginUser.ads;
                if(this.currentIdx === dataList.length - 1){
                    this.$emit('input', false);
                    this.read();
                    return;
                }
                this.currentIdx += 1;
                this.nextNews(this.currentIdx);
            },
            nextNews(idx){
                let dataList = this.$store.state.app.loginUser.ads;
                 this.currentItem = dataList[idx];
            },
            read(){
                let ids = this.$store.state.app.loginUser.ads.map((item) => {return item.id});
                if(ids.length > 0){
                    newsService.readNews(ids).then(() => {
                        this.$store.commit('app/del_ads');
                    });
                }
            },
            onClose(){
                this.$emit('input', false);
                this.read();
            }
        }
    }
</script>
<style lang="scss">
    @import "./news-view";
</style>